<template>
  <v-container class="white lighten-5">
    <v-row>
      <v-col>
        <h3 class="mb-4">SHIPPER'S DECLARATION FOR DANGEROUS GOODS</h3>
        
        <!-- PDF Viewer -->
        <v-card>
          <div class="pdf-container" ref="pdfContainer">
            <!-- PDF Display as object -->
            <object
              ref="pdfViewer"
              :data="pdfSource"
              type="application/pdf"
              class="pdf-viewer"
              @load="onPdfLoaded"
            >
              <p>Your browser doesn't support PDF viewing. 
                <a :href="pdfSource" target="_blank">Download the PDF</a>
              </p>
            </object>
          </div>
        </v-card>

        <!-- Upload edited PDF section -->
        <v-card class="mt-4" v-if="showUploadSection">
          <v-card-title>Shippers Declaration senden</v-card-title>
          <v-card-text>
            <p>Nachdem du mit der Bearbeitung fertig bist, lade bitte die PDF Datei mit dem Download Button (oben rechts) mit den Änderungen herunter und lade die Datei im nächsten Feld wieder hoch:</p>
            <v-file-input
              v-model="editedPdfFile"
              accept=".pdf"
              label="Select edited PDF file"
              prepend-icon="mdi-file-pdf-box"
              show-size
              @change="onFileSelected"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="submitEditedPdf" :disabled="!editedPdfFile" :loading="saving">
              <v-icon left>mdi-upload</v-icon>
              Kurs jetzt abschließen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'

export default {
  name: "ShippersDeclarationComponent",
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      pdfSource: '/img/shippers-declaration.pdf',
      saving: false,
      pdfLoaded: false,
      showUploadSection: false,
      editedPdfFile: null
    }
  },
  mounted() {
    // Show upload section after PDF loads
    setTimeout(() => {
      this.showUploadSection = true
    }, 1000)
  },
  methods: {
    onPdfLoaded() {
      this.pdfLoaded = true
      this.showUploadSection = true
    },
    
    onFileSelected(file) {
      this.editedPdfFile = file
    },
    
    async submitEditedPdf() {
      if (!this.editedPdfFile) {
        alert('Please select a PDF file first.')
        return
      }
      
      this.saving = true
      
      try {
        const formData = new FormData()
        formData.append('editedPdf', this.editedPdfFile)
        formData.append('originalPdf', this.pdfSource)
        formData.append('timestamp', new Date().toISOString())
        
        const response = await axios.post('/api/shippers-declaration/submit', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        
        this.$emit('submitted', response.data)
        alert('PDF submitted successfully!')
        
        // Reset form
        this.editedPdfFile = null
        
      } catch (error) {
        console.error('Upload failed:', error)
        alert('Failed to upload PDF. Please try again.')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>


<style scoped>
.pdf-container {
  position: relative;
  width: 100%;
  height: 800px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  border: none;
}

.form-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 15;
}

.form-field {
  pointer-events: auto;
}

.form-field .v-input__control {
  min-height: auto !important;
}

.form-field .v-text-field__details {
  display: none !important;
}

.form-field .v-input__slot {
  min-height: auto !important;
  margin-bottom: 0 !important;
}

.v-card {
  overflow: visible;
}
</style>
